<template>
  <div class="white fill-height d-flex flex-column">
    <AbstractCourseHeader title="Serwis" @openSettlementColumn="$emit('openSettlementColumn')" @close="$emit('close')">
      <ServiceCourseBadge />
    </AbstractCourseHeader>
    <TaxiCourseGeneralInfo class="mx-6 my-4" :course="course"></TaxiCourseGeneralInfo>
    <v-divider></v-divider>
    <section class="mx-6 my-4">
      <BaseTypography variant="subtitle-2" class="py-4">Serwisy w kursie</BaseTypography>
      <SettingsElement
        v-for="(ride, idx) in course.rides"
        :key="ride.id"
        :title="`Serwis ${ride.number}`"
        :subtitle="ride.company.name"
        :input-value="0 === idx"
        @click="$emit('update:selectedRide', idx)"
      ></SettingsElement>
    </section>
    <v-divider></v-divider>
  </div>
</template>

<script>
import ServiceCourseBadge from '@/component/NewCourse/CourseCard/CourseBadge/service-course-badge';
import BaseTypography from '@/component/Base/base-typography';
import SettingsElement from '@/controller/Settings/SettingsOverview/settings-element';
import AbstractCourseHeader from '../header/abstract-course-header';
import TaxiCourseGeneralInfo from '../Details/taxi-course-general-info';

export default {
  name: 'ServiceCourseDrawer',
  components: {
    AbstractCourseHeader,
    ServiceCourseBadge,
    TaxiCourseGeneralInfo,
    BaseTypography,
    SettingsElement,
  },
  props: {
    course: Object,
  },
};
</script>

<style lang="scss" scoped></style>
